import { makeStyles } from '@material-ui/core/styles';
import { Typography, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        marginTop: 150,
        padding: theme.spacing(3),
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column'
    },
    image: {
        display: 'inline-block',
        marginTop: 50,
        maxWidth: '100%',
        width: 560
    }
}));

const Error401 = (props: any) => {
    const classes = useStyles(props);

    return (
        <div className={classes.root}>
            <Typography
                align="center"
                variant="h1"
            >
                401: Sorry, we're unable to authenticate you
            </Typography>
            <Typography
                align="center"
                variant="subtitle2"
            >
                You either tried some shady route or you came here by mistake. Whichever it is, try using the navigation
            </Typography>
            <img
                alt="Internal server error"
                className={classes.image}
                src="/images/errors/401.svg"
            />
        </div>
    );
};

export default Error401;
